export const ONBOARDING_RETAIL_HYBRID_CODES = [
  'retail_hybrid_advantage',
  'synergy_retail_hybrid_advantage',
]
